import React from 'react'
import FooterLogo from './../../assets/images/footer_logo.svg'
import Clutch from './../../assets/images/clutch.png'
import Instagram from './../../assets/images/instagram.svg'
import Facebook from './../../assets/images/facebook.svg'
import Twitter from './../../assets/images/twitter.svg'
import LinkedIn from './../../assets/images/linkedin.svg'
import YouTube from './../../assets/images/youtube.svg'
import './Footer.scss'
import { NavLink } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { SITE_CONFIG, getCopyrightText } from '../../config/siteConfig'

export default function Footer() {

  const ClickHome = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Home Click'
      },
    });
  }
  const ClickAbout = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer About Click'
      },
    });
  }
  const ClickServices = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Services Click'
      },
    });
  }
  const ClickIndustries = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Industries Click'
      },
    });
  };
  const ClickOurWork = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Our-Work Click'
      },
    });
  }
  const ClickOurClients = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Our-Clients Click'
      },
    });
  }
  const ClickCaseStudies = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Case-Studies Click'
      },
    });
  }
  const ClickContact = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Contact Click'
      },
    });
  }
  const ClickCareer = () =>{
    TagManager.dataLayer({ 
      dataLayer: {
        event: 'Footer Career Click'
      },
    });
  }

  return (
    <footer>
      <div className="social_icons">
        <a href={SITE_CONFIG.social.facebook} target='_blank' rel="noreferrer" className="social_box">
          <img src={Facebook} alt="" />Facebook
        </a>
        <a href={SITE_CONFIG.social.youtube} target='_blank' rel="noreferrer" className="social_box">
          <img src={YouTube} alt="" />Youtube
        </a>
        <a href={SITE_CONFIG.social.instagram} target='_blank' rel="noreferrer" className="social_box">
          <img src={Instagram} alt="" />Instagram
        </a>
        <a href={SITE_CONFIG.social.clutch} target='_blank' rel="noreferrer" className="social_box">
          <img src={Clutch} alt="" />Clutch
        </a>
        <a href={SITE_CONFIG.social.twitter} target='_blank' rel="noreferrer" className="social_box">
          <img src={Twitter} alt="" />Twitter
        </a>
        <a href={SITE_CONFIG.social.linkedin} target='_blank' rel="noreferrer" className="social_box">
          <img src={LinkedIn} alt="" />Linkedin
        </a>
      </div>
      <div className="footer_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="top">
                <div className="logo"><img src={FooterLogo} alt="" /></div>
                <div className="content">
                  <div className="title">Leading companies trust us</div>
                  <div className="desc">KoolMind Technolab is the one-stop solution for all kinds of Mobile Apps, Web Apps & Software Development services.</div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div className="row">
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <div className="link_title">Company</div>
                  <div className="links">
                    <NavLink to="/" onClick={ClickHome}>Home</NavLink>
                    <NavLink to="/about" onClick={ClickAbout}>About Us</NavLink>
                    <NavLink to="/contact" onClick={ClickContact}>Contact Us</NavLink>
                    <NavLink to="/services" onClick={ClickServices}>Services</NavLink>
                    <NavLink to="/our-clients" onClick={ClickOurClients}>Our Teams</NavLink>
                    <NavLink to="/our-clients" onClick={ClickOurClients}>Testimonials</NavLink>
                    <NavLink to="/contact" onClick={ClickContact}>Contact Us</NavLink>
                  </div>
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <div className="link_title">About</div>
                  <div className="links">
                    <NavLink to="/about" onClick={ClickAbout}>About Us</NavLink>
                    <NavLink to="/our-story" onClick={ClickAbout}>Our Story</NavLink>
                    <NavLink to="/our-journey" onClick={ClickAbout}>Our Journey</NavLink>
                    <NavLink to="/life-at-koolmind" onClick={ClickAbout}>Life at KoolMind</NavLink>
                    <NavLink to="/our-works" onClick={ClickOurWork}>Our Works</NavLink>
                    <NavLink to="/case-studies" onClick={ClickCaseStudies}>Case Studies</NavLink>
                    <NavLink to="/our-clients" onClick={ClickOurClients}>Our Clients</NavLink>
                    <NavLink to="/career" onClick={ClickCareer}>Career</NavLink>
                  </div>
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <div className="link_title">Services</div>
                  <div className="links">
                    <NavLink to="/services" onClick={ClickServices}>All Services</NavLink>
                    <NavLink to="/services/mobile-app-development" onClick={ClickServices}>Mobile App Development</NavLink>
                    <NavLink to="/services/web-app-development" onClick={ClickServices}>Web App Development</NavLink>
                    <NavLink to="/services/ui-ux-designing" onClick={ClickServices}>UI/UX Design</NavLink>
                    <NavLink to="/services/ai-machine-learning-development" onClick={ClickServices}>AI/ML Development</NavLink>
                    <NavLink to="/services/mcp-development" onClick={ClickServices}>MCP Development</NavLink>
                  </div>
                </div>
                <div className="col-md-3 col-lg-3 col-xl-3">
                  <div className="link_title">Industries</div>
                  <div className="links">
                    <NavLink to="/industries" onClick={ClickIndustries}>All Industries</NavLink>
                    <NavLink to="/industries/healthcare" onClick={ClickIndustries}>Healthcare</NavLink>
                    <NavLink to="/industries/education" onClick={ClickIndustries}>Education</NavLink>
                    <NavLink to="/industries/petcare" onClick={ClickIndustries}>PetCare</NavLink>
                    <NavLink to="/industries/homecare" onClick={ClickIndustries}>Homecare</NavLink>
                    <NavLink to="/industries/social-media" onClick={ClickIndustries}>Social Media</NavLink>
                    <NavLink to="/industries/dating" onClick={ClickIndustries}>Dating</NavLink>
                    <NavLink to="/industries/fitness" onClick={ClickIndustries}>Fitness</NavLink>
                    <NavLink to="/industries/textile-garments" onClick={ClickIndustries}>Textile Garments</NavLink>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copy_right">
        <p>{getCopyrightText()}</p>
      </div>
    </footer>
  )
}

